import cfg, {handleResponse, handlePrepareData} from "../constants";
import {authMiddleware} from "./loginAction";


// getSettingsAction - get settings
export const getSettingsAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/admin-settings', {
    method: "GET",
    headers: headers
  }).then(handleResponse).then(handlePrepareData);
};

// updateSettingsAction - save user profile
export const updateSettingsAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/admin-settings', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};